import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_5: FaireProductEntity = {
  token: "atc_updated_fs_rec_5",
  type: "product",
  name: "Pastel Gradient Dessert Tableware Set",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/cc30f2e90a27693c4bf6d6b2cd7b519f5fea69c97a40ad42cba78f8267dcdd12.jpeg",
  priceDollars: 48,
  msrpDollars: 96,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
